/**
 * Centralized feature toggles for gradually rolling out or pausing UI features.
 * Keep values as `true` only when the corresponding UI should be visible.
 */
export const PLAYER_ASSETS_ENABLED = true;
export const PLAYER_PUBLIC_ID_VISIBLE = true;
export const SEASON_VERTICAL_MEDIA_ENABLED = true;